import PropTypes from 'prop-types';

const dataToCompPropType = PropTypes.arrayOf(PropTypes.shape({
  dataMask: PropTypes.string,
  dataToProps: PropTypes.objectOf(PropTypes.string)
}));

export default dataToCompPropType;
